import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-todays-closed-tickets',
  templateUrl: './todays-closed-tickets.component.html',
  styleUrls: ['./todays-closed-tickets.component.css']
})
export class TodaysClosedTicketsComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetTodaysClosedTickets();
  }

  GetTodaysClosedTickets = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getTodaysClosedTickets()
    .subscribe((data:any)=>{
      this.TicketsList = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/todays-closed-tickets/todays-closed-tickets.component.ts